import { legacyPageUrl, legacySiteUrl, externalUrl, contenidoSeccionConfig, contenidoTreeConfig } from './commonConfig';
import { managedLinkInfo } from 'src/common/managedLinkKey';


const legacyBaseUrl: string = "https://hiba.hospitalitaliano.org.ar";

export const environment = {
	production: true,
	backendUrl: "https://intranet-back.hospitalitaliano.org.ar/api",
	legacyBaseUrl: legacyBaseUrl,
	legacyIndexUrl: legacyBaseUrl + "/intranet",
	legacyLogoutUrl: legacyBaseUrl + "/login/logout.php",
	mailboxUrl: "https://accounts.google.com/Logout?continue=https://mail.google.com/a/hospitalitaliano.org.ar/Logout",
	legacyPageUrl: legacyPageUrl,
	legacySiteUrl: legacySiteUrl,
	externalUrl: externalUrl,
	managedLinkInfo: managedLinkInfo,
	jiraBaseUrl: [ "https://jira.*\\.hospitalitaliano\\.org\\.ar", "https://gestiones.*\\.hospitalitaliano\\.org\\.ar" ],
	moodleBaseUrl: "https://campus-hi.hospitalitaliano.org.ar",
	legacyControlSesionBaseUrl: "https://hiba.hospitalitaliano.org.ar",
	contenidoSeccionConfig: contenidoSeccionConfig,
	contenidoTreeConfig: contenidoTreeConfig,
	googleAnalyticsTrackingId: "UA-175790425-1",
	emailAccesoUrl: "https://hiba.hospitalitaliano.org.ar/comunita/api",
	humandUrl: "https://app.humand.co/"
};
